import { GearFill } from '@styled-icons/bootstrap';
import { ComponentProps } from 'react';
import styled from 'styled-components';

const SettingButtonContainer = styled.div`
  padding: 12px 16px;
  white-space: nowrap;
  border-radius: 6px;
  background-color: var(--background-button);
  box-shadow: var(--shadow-button);
  cursor: pointer;
  color: var(--accent);
`;

type SettingButtonProps = ComponentProps<typeof SettingButtonContainer> & {
  onClick: (e: MouseEvent) => void;
};

/**
 * Button to show the setting menu for
 * the dropdown menu's elements.
 */
export function SettingButton(props: SettingButtonProps) {
  const { children } = props;
  return (
    <SettingButtonContainer
      role="none"
      contentEditable={false}
      {...props}
    >
      <GearFill size={21} style={{ marginRight: 8 }} />
      {children}
    </SettingButtonContainer>
  );
}
